import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { normalizeSocialLink as m } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as i } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as c } from "../../../store/index.mjs";
import { S3_BUCKET_URL as d } from "../../../constants/s3-bucket-url.mjs";
import { StoreImageEnum as p } from "../../../enums/store-image-enum.mjs";
const E = ({ profile: r, socialLinks: l }) => {
  var o;
  const { locale: a } = c();
  return /* @__PURE__ */ n(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: `url(${d}/images/profile-background/luminous-profile-background.png)`
      },
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none p-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ e(
          s,
          {
            width: 96,
            height: 96,
            imageType: p.profile,
            alt: r.sellerName,
            src: (o = r.sellerPhoto) == null ? void 0 : o.path,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ n("div", { className: "flex flex-col items-center justify-center gap-3", children: [
          /* @__PURE__ */ e(
            "h1",
            {
              id: "region-heading",
              lang: a,
              className: "text-THEME-primary break-all text-center text-2xl font-bold",
              children: r.sellerName
            }
          ),
          /* @__PURE__ */ e("span", { lang: a, className: "hyphens-auto text-center text-[16px] font-normal ", children: r.bio })
        ] }),
        !!l.length && /* @__PURE__ */ e("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: l.map((t) => /* @__PURE__ */ e(
          "a",
          {
            href: m(t),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            "aria-label": t.type,
            children: i(t.type, "fill-THEME-text-secondary")
          },
          t.type
        )) })
      ]
    }
  );
};
export {
  E as ProfileLuminous
};
